import { render, staticRenderFns } from "./TopTraitsAccordion.vue?vue&type=template&id=47a7792c"
import script from "./TopTraitsAccordion.vue?vue&type=script&lang=js"
export * from "./TopTraitsAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports